var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0_logo_F4L_CB_black",
    "data-name": "0_logo_F4L+CB_black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 80.626,
    viewBox: "0 0 268 80.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(0)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M212.259,776.573H188.7v17.038h-7.293V771.074c0-8.25,1.315-11.658,5.62-14.707,3.049-1.973,6.337-2.69,12.554-2.63h12.674v5.978H199.764c-7.592-.119-10.94,2.511-11.06,8.669V770.6h23.554Z",
    transform: "translate(-181.411 -753.733)",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M401.627,753.754h6.755v6.815h-6.755Zm6.755,10.761v29.114h-6.755V764.515Z",
    transform: "translate(-365.578 -753.751)",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M479.255,753.754h6.755v10.761h8.071v5.321H486.01v13.152c-.06,4.424.658,5.261,4.783,5.321h3.288v5.321h-5.739c-6.7.12-9.206-2.571-9.087-9.745V769.836h-5.321v-5.321h5.321Z",
    transform: "translate(-426.049 -753.751)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(71.08 0.003)",
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M615.629,778.624l22.837-24.87h10.342V779.4h5.62v5.978h-5.62v8.25h-7.293v-8.25H615.629Zm25.886.777V759.852L623.58,779.4Z",
    transform: "translate(-615.629 -753.754)",
    fill: "#1ba8f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(115.378 0.003)",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M893.533,753.754v22.837c.12,5.62.538,7.413,1.913,8.788,1.614,1.554,4.544,2.332,8.728,2.272h8.369v5.978H903.1c-7.174-.06-9.685-.717-13.032-3.587-2.81-2.69-3.766-5.859-3.826-13.033V753.754Z",
    transform: "translate(-886.24 -753.754)",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M1073.222,753.754h6.755v6.815h-6.755Zm6.755,10.761v29.114h-6.755V764.515Z",
    transform: "translate(-1042.614 -753.754)",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M1164.928,819.491h7.174L1159.069,848.6h-6.457l-12.2-29.114h7.413l8.25,20.924Z",
    transform: "translate(-1098.809 -808.73)",
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M1360.268,753.754h6.755v6.815h-6.755Zm6.755,10.761v29.114h-6.755V764.515Z",
    transform: "translate(-1282.671 -753.754)",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M1465.549,819.457c8.13-.179,11.717,3.288,11.717,11.538v17.576h-6.755v-17.7c0-4.424-1.614-6.158-5.679-6.1h-6.875v23.794H1451.2V819.457Z",
    transform: "translate(-1358.719 -808.696)",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M1673.82,846.692c-.06,5.739-.359,7.114-1.793,8.908-1.853,2.092-4.244,2.75-9.685,2.75h-13.989v-5.321H1662.4c4.125,0,4.723-.538,4.663-4.424h-6.756c-5.081,0-7.233-.538-9.744-2.391-3.348-2.451-5.082-6.516-5.082-11.837,0-4.9,1.554-9.087,4.424-11.717,2.571-2.391,5.2-3.169,10.582-3.169h13.332Zm-12.913-21.881c-3.527,0-5.38.717-6.7,2.511-1.076,1.495-1.734,4.245-1.734,7.114a10.567,10.567,0,0,0,1.973,6.636c1.315,1.554,3.049,2.212,6.1,2.212h6.516V824.812Z",
    transform: "translate(-1521.198 -808.73)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Coach_Buddy",
    "data-name": "Coach Buddy",
    transform: "translate(46.017 55.81)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    style: {
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M478.632,1114.606h-6.516c-3.378,0-5.321-.538-6.815-1.943-1.764-1.644-2.78-4.514-2.78-7.921,0-4.005,1.435-7.323,3.766-8.818a11.363,11.363,0,0,1,5.8-1.256h6.546v2.989h-6.217c-2.272,0-3.617.448-4.514,1.495a9.1,9.1,0,0,0-1.4,5.47c0,2.571.628,4.633,1.7,5.709.956.927,2.182,1.285,4.424,1.285h6.008Z",
    transform: "translate(-462.521 -1094.669)",
    fill: "#231f20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M585.348,1134.035c0,4.543-2.87,7.323-7.592,7.323-4.783,0-7.5-2.69-7.5-7.383,0-4.663,2.9-7.533,7.592-7.533C582.628,1126.443,585.348,1129.193,585.348,1134.035Zm-11.6-.09c0,3.109,1.375,4.723,4.036,4.723s4.065-1.614,4.065-4.693c0-3.139-1.435-4.843-4.065-4.843S573.75,1130.807,573.75,1133.946Z",
    transform: "translate(-552.618 -1121.242)",
    fill: "#231f20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M686.92,1133.168c.06-2.421-.6-3.049-3.169-3.019h-6.815v-2.66h7.144c4.663-.15,6.307,1.375,6.217,5.8v8.758h-7.831c-2.87,0-3.677-.15-4.633-.807a4.186,4.186,0,0,1-1.674-3.557,4.345,4.345,0,0,1,2.152-4.006,8.393,8.393,0,0,1,3.557-.508Zm-4.753,2.66a3.859,3.859,0,0,0-1.584.179,1.631,1.631,0,0,0-.957,1.614c0,1.286.688,1.764,2.541,1.764h4.753v-3.557Z",
    transform: "translate(-641.187 -1122.108)",
    fill: "#231f20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M792.369,1130.2h-4.693c-3.109,0-4.334,1.315-4.334,4.693a4.736,4.736,0,0,0,1.315,3.707c.717.628,1.554.837,3.228.837h4.484v2.661h-5.022c-2.87,0-4.394-.508-5.62-1.823a8.753,8.753,0,0,1,.209-11.03c1.255-1.226,2.72-1.7,5.41-1.7h5.022Z",
    transform: "translate(-727.925 -1122.158)",
    fill: "#231f20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M875.284,1100.05h3.707c4.693-.03,6.337,1.524,6.337,5.948v8.609h-3.378v-8.37c.06-2.75-.687-3.527-3.348-3.527h-3.318v11.9h-3.378v-19.937h3.378Z",
    transform: "translate(-804.891 -1094.669)",
    fill: "#231f20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M1023.462,1094.669h10.312c2.272,0,3.646.329,4.723,1.076a4.962,4.962,0,0,1,1.973,4.1,4.852,4.852,0,0,1-3.019,4.663,4.52,4.52,0,0,1,3.168,4.6,5.128,5.128,0,0,1-2.421,4.633c-1.046.6-2.571.867-4.992.867h-9.745Zm9.745,8.34a3.438,3.438,0,0,0,2.361-.538,2.808,2.808,0,0,0,.986-2.212,2.764,2.764,0,0,0-.837-2.033c-.568-.448-1.076-.568-2.481-.568h-6.128v5.351Zm-.15,8.609c2.421,0,3.587-.957,3.587-2.93,0-1.883-1.016-2.69-3.408-2.69h-6.128v5.62Z",
    transform: "translate(-931.638 -1094.669)",
    fill: "#231f20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M1156.034,1127.539h3.378V1142.1h-7.025c-4.184.179-6.038-1.584-6.038-5.8v-8.758h3.378v8.878c0,2.272.687,2.989,2.84,3.019h3.467Z",
    transform: "translate(-1034.409 -1122.158)",
    fill: "#231f20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M1255.624,1094.669H1259v19.938h-6.636c-2.69,0-4.035-.388-5.261-1.465a7.545,7.545,0,0,1-2.152-5.709,7.688,7.688,0,0,1,2.391-6.008,7.155,7.155,0,0,1,4.753-1.375h3.527Zm0,8.041h-3.019c-2.78,0-4.185,1.495-4.185,4.514,0,3.2,1.285,4.723,3.946,4.723h3.258Z",
    transform: "translate(-1116.872 -1094.669)",
    fill: "#231f20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M1360.254,1094.669h3.377v19.938H1357c-2.69,0-4.035-.388-5.261-1.465a7.544,7.544,0,0,1-2.152-5.709,7.688,7.688,0,0,1,2.391-6.008,7.154,7.154,0,0,1,4.752-1.375h3.528Zm0,8.041h-3.019c-2.78,0-4.185,1.495-4.185,4.514,0,3.2,1.285,4.723,3.946,4.723h3.258Z",
    transform: "translate(-1204.374 -1094.669)",
    fill: "#231f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M1467.964,1127.539h3.378v13.122c-.03,4.813-1.614,6.427-6.187,6.307H1458.4v-2.66h6.666c2.391.03,2.87-.3,2.9-2.212h-3.826c-2.242.06-3.617-.448-4.723-1.7-.837-1.106-1.046-2.033-1.016-4.783v-8.071h3.378v8.31c0,2.81.538,3.557,2.69,3.587h3.5Z",
    transform: "translate(-1295.375 -1122.158)",
    fill: "#231f20"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.3db0d1230efa27a99e5445c260a1eada.svg";
export { ForwardRef as ReactComponent };